/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_Triple_CoinInputs */

const en_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn 3× rewards to unlock new trees faster`)
};

const ar_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكسب مكافآت بثلاثة أضعاف لفتح أشجار جديدة بشكل أسرع`)
};

const de_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiene 3× Belohnungen, um neue Bäume schneller freizuschalten`)
};

const es_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana 3 veces más recompensas para desbloquear nuevos árboles más rápido`)
};

const fr_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triplez vos récompenses pour débloquer des nouveaux arbres plus rapidement`)
};

const it_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni ricompense 3 volte superiori per sbloccare nuovi alberi più velocemente`)
};

const ja_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報酬が3倍になり、より早く木のアンロックが可能`)
};

const ko_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드를 3배 더 받아 새로운 나무를 보다 빠르게 획득할 수 있어요`)
};

const pt_br_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe 3x mais recompensas para desbloquear novas espécies mais rápido`)
};

const ru_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте в 3 раза больше наград, чтобы быстрее разблокировать новые деревья`)
};

const th_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับรางวัลเพิ่ม 3 เท่าเพื่อปลดล็อกต้นไม้ใหม่ได้เร็วขึ้น`)
};

const tr_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ağaçların kilidini daha hızlı açmak için 3 kat ödül kazan`)
};

const zh_cn_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 倍专注奖励，解锁新树更快`)
};

const zh_tw_onboarding_paywall_benefit_triple_coin = /** @type {(inputs: Onboarding_Paywall_Benefit_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 倍專注獎勵，解鎖新樹更快`)
};

/**
* | output |
* | --- |
* | "Earn 3× rewards to unlock new trees faster" |
*
* @param {Onboarding_Paywall_Benefit_Triple_CoinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_triple_coin = /** @type {((inputs?: Onboarding_Paywall_Benefit_Triple_CoinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_Triple_CoinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_triple_coin(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_triple_coin(inputs)
	return zh_tw_onboarding_paywall_benefit_triple_coin(inputs)
});